const d = "_header_1gro4_1", e = "_content_1gro4_5", o = "_arrow_1gro4_21", n = "_slideDownAndFade_1gro4_1", r = "_slideLeftAndFade_1gro4_1", t = "_slideUpAndFade_1gro4_1", _ = "_slideRightAndFade_1gro4_1", a = {
  header: d,
  content: e,
  arrow: o,
  "arrow--start": "_arrow--start_1gro4_27",
  "arrow--end": "_arrow--end_1gro4_30",
  slideDownAndFade: n,
  slideLeftAndFade: r,
  slideUpAndFade: t,
  slideRightAndFade: _
};
export {
  o as arrow,
  e as content,
  a as default,
  d as header,
  n as slideDownAndFade,
  r as slideLeftAndFade,
  _ as slideRightAndFade,
  t as slideUpAndFade
};
//# sourceMappingURL=index.es2439.js.map
